import React from 'react';
// import { useDispatch } from "react-redux";
import { Route, Redirect } from 'react-router-dom';

import { getAccessToken } from '../utils/helpers/tokenHelper';
import { getUserRole } from '../utils/helpers/userHelper';

//import { stopPolling } from '../redux/actions/base/newCountAction';

export const PrivateRoute = ({ component: Component, accessRoles, extraProps, ...rest }) => {
  // const dispatch = useDispatch();

  return (
    <Route {...rest} render={props => {
      if (!getAccessToken()) {
        localStorage.clear();
        return <Redirect to={{ pathname: '/auth/login', state: { from: props.location } }} />;
      }

      if (accessRoles && !accessRoles.includes(getUserRole())) {
        return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
      }

      if (extraProps) {
        props = Object.assign({}, props, extraProps);
      }

      return <Component {...props} />;
    }} />
  )

};

